/* eslint-disable global-require */
import i18n, { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { continueLaterLocalization } from '@vwfs-its/sf-sac-frontend';
import { configKey } from '../../config';
import { merge } from 'lodash';

const localization = continueLaterLocalization({
  locale: 'de',
  brandName: { configKey }
});

use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'de',
    keySeparator: '.', // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });
i18n.addResourceBundle('de', 'sf-sac', localization, true, true);
export default resourceKey => {
  return new Promise(res => {
    const namespaces = [
      'page',
      'validation',
      'form',
      'app',
      'step1',
      'step2',
      'step3',
      'step4',
      'step5',
      'license'
    ];
    Promise.all(
      namespaces.map(item => {
        return Promise.all([
          import(
            `../../resources/common/content/${item}.json`
          ).catch(() => ({ default: {} })),
          import(
            `../../resources/${resourceKey}/content/${item}.json`
          ).catch(() => ({ default: {} }))
        ]).then(([genericModule, brandModule]) => {
          i18n.addResourceBundle(
            'de',
            item,
            merge({}, genericModule.default, brandModule.default),
            true,
            true
          );
        });
      })
    ).then(res);
  });
};
